import { render, staticRenderFns } from "./driver_info.vue?vue&type=template&id=24a7ac3b&scoped=true&"
import script from "./driver_info.vue?vue&type=script&lang=js&"
export * from "./driver_info.vue?vue&type=script&lang=js&"
import style0 from "./driver_info.vue?vue&type=style&index=0&id=24a7ac3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7ac3b",
  null
  
)

export default component.exports